import PropTypes from "prop-types";
import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "reactstrap";

const UploadForm = props => {
  const { handleFiles, multiple, accept, removeFile } = props;
  const { t } = useTranslation("common");
  const [selectedFiles, setSelectedFiles] = useState([]);

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
    handleFiles && handleFiles(files);
  }

  //   resetSelectFile=()=>{
  //     setSelectedFiles([]);
  //   }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const onDeleteSingleFileHandler = file => {
    const newItems = selectedFiles.filter(item => item !== file);
    setSelectedFiles(newItems);
    removeFile(file);
  };

  return (
    <React.Fragment>
      <Dropzone
        // accept=".xlsx"
        accept={accept}
        multiple={multiple}
        onDrop={acceptedFiles => {
          handleAcceptedFiles(acceptedFiles);
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div className="dz-message needsclick mt-2" {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="mb-3">
                <i className="display-4 text-muted bx bxs-cloud-upload" />
              </div>
              <h4>{t("dropFilesUpload")}</h4>
            </div>
          </div>
        )}
      </Dropzone>
      <div className="dropzone-previews mt-3" id="file-previews">
        {selectedFiles.map((f, i) => {
          return (
            <Card
              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
              key={i + "-file"}
            >
              <div className="p-2">
                <Row className="align-items-center">
                  {typeof removeFile === "function" && (
                    <Col className="col-auto">
                      <Link to="#" onClick={() => onDeleteSingleFileHandler(f)}>
                        <i className="fas fa-trash fa-lg text-danger"></i>
                      </Link>
                    </Col>
                  )}
                  <Col>
                    <Link to="#" className="text-muted font-weight-bold">
                      {f.name}
                    </Link>
                    <p className="mb-0">
                      <strong>{f.formattedSize}</strong>
                    </p>
                  </Col>
                </Row>
              </div>
            </Card>
          );
        })}
      </div>
    </React.Fragment>
  );
};

UploadForm.propTypes = {
  t: PropTypes.any,
  accept: PropTypes.any,
  multiple: PropTypes.bool,
  handleFiles: PropTypes.func,
  removeFile: PropTypes.func,
};

export default UploadForm;
